export { Icons, IconsProps, IconName } from "./Icons.component";
